import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TaskCard = ({ task, onStatusUpdate, onTimeLog, onViewDetails }) => {
  const getPriorityColor = (priority) => {
    switch (priority?.toLowerCase()) {
      case 'high':
        return 'text-error bg-error/10 border-error/20';
      case 'medium':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'low':
        return 'text-success bg-success/10 border-success/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed':
        return 'text-success bg-success/10 border-success/20';
      case 'in progress':
        return 'text-primary bg-primary/10 border-primary/20';
      case 'pending':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'overdue':
        return 'text-error bg-error/10 border-error/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const isOverdue = new Date(task.dueDate) < new Date() && task?.status !== 'Completed';

  return (
    <div className="bg-card border border-border rounded-lg p-4 card-shadow hover:shadow-md transition-smooth">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h3 className="text-base font-semibold text-foreground mb-1 line-clamp-2">
            {task?.title}
          </h3>
          <p className="text-sm text-muted-foreground mb-2 line-clamp-2">
            {task?.description}
          </p>
        </div>
        <div className="flex items-center space-x-2 ml-4">
          <span className={`px-2 py-1 rounded-full text-xs font-medium border ${getPriorityColor(task?.priority)}`}>
            {task?.priority}
          </span>
        </div>
      </div>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-4 text-sm text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="Calendar" size={14} />
            <span className={isOverdue ? 'text-error font-medium' : ''}>
              Due: {new Date(task.dueDate)?.toLocaleDateString()}
            </span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="User" size={14} />
            <span>{task?.assignedBy}</span>
          </div>
        </div>
        <span className={`px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(task?.status)}`}>
          {task?.status}
        </span>
      </div>
      {task?.timeLogged && (
        <div className="flex items-center space-x-1 text-sm text-muted-foreground mb-3">
          <Icon name="Clock" size={14} />
          <span>Time logged: {task?.timeLogged}</span>
        </div>
      )}
      <div className="flex items-center justify-between pt-3 border-t border-border">
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Play"
            iconPosition="left"
            onClick={() => onTimeLog(task?.id)}
          >
            Log Time
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Eye"
            onClick={() => onViewDetails(task?.id)}
          >
            Details
          </Button>
        </div>
        <div className="flex items-center space-x-2">
          {task?.status !== 'Completed' && (
            <Button
              variant="default"
              size="sm"
              iconName="CheckCircle"
              onClick={() => onStatusUpdate(task?.id, 'Completed')}
            >
              Complete
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskCard;